import './quarter.scss'

const selector = '.quarter'
const escButtonKeyCode = 27

const fourQuarters = el => {
  const quarters = Array.from(el.querySelectorAll(selector))
  quarters.forEach(quarter => {
    const open = () => {
      quarter.classList.add('quarter--active')
    }
    const close = () => {
      quarter.classList.remove('quarter--active')
    }
    const bg = quarter.querySelector('.quarter__bg')
    if (bg) {
      bg.addEventListener('click', open)
    }
    const toggle = quarter.querySelector('.quarter__toggle')
    if (toggle) {
      toggle.addEventListener('click', () => {
        close()
      })
    }
    quarter.querySelectorAll('[data-quarter-open]').forEach(el2 => {
      el2.addEventListener('click', open)
    })
  })
}

const closeAll = () => {
  document.querySelectorAll(selector).forEach(quarter => {
    quarter.classList.remove('quarter--active')
  })
}

document.documentElement.addEventListener('click', e => {
  if (!e.target.closest(selector)) {
    closeAll()
  }
})

document.documentElement.addEventListener('keydown', e => {
  if (e.keyCode === escButtonKeyCode) {
    closeAll()
  }
})

export default fourQuarters
